<template>
    <div class="row">
        <div v-if="ready">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="quota">Maksymalna liczba zapytań</label>
                    <input id="quota" v-model="quota" :disabled="disableButton" type="number" class="form-control" @keyup="isNumber()">
                </div>
                <div v-if="!disableButton">
                    <button :disabled="disableButton" class="btn btn-primary" @click="save">Zapisz</button>
                </div>
                <div v-else>
                    <RingLoader v-if="disableButton"></RingLoader>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="requests-count">Wykorzystana liczba zapytań</label>
                    <input id="requests-count" v-model="requestsCount" class="form-control" disabled>
                </div>
            </div>
        </div>
        <div v-if="!ready">
            <RingLoader></RingLoader>
        </div>
    </div>
</template>

<script>
import toastr from '../toastr'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
export default {
  name: 'RouteMismatchQuoteForm',
  components: { RingLoader },
  data() {
    return {
      quota: 0,
      requestsCount: 0,
      disableButton: false,
      ready: false
    }
  },
  async mounted() {
    let data = await this.getData()
    this.quota = data.quota
    this.requestsCount = data.requestsCount
    this.ready = true
  },
  methods: {
    isNumber() {
      this.quota = parseInt(this.quota) || 0
    },
    async sendRequest() {
      return $.post({
        url: Routing.generate('api_config_update_region_quota'),
        data: {
          quota: this.quota
        }
      })
    },
    async save() {
      this.disableButton = true
      await this.sendRequest()
      toastr.success('Zapisano pomyślnie')
      this.disableButton = false
    },
    async getData() {
      return $.get({
        url: Routing.generate('api_config_get_region_quota')
      })
    },
  }
}
</script>
